import React from "react";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import Switch from "../Switch/Switch";

class FolioWidget extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var folios = this.renderFolioDetails();

    return(
        <div className="panel panel-default">
          <div className="panel-body container">
            <div className="flexed" style={{ borderBottom: '1px solid #DFDFDF', marginBottom: '1rem' }}>
              <h3 className="panel-heading-text col-sm-6" style={{padding:'1rem 1rem 0px', marginBottom:'1rem'}}>{I18n.t('folios')}</h3>
              {this.props.capture_auth ? <div key="add-buttom" className="col-sm-6 content-right flexed" style={{ marginBottom: 15, paddingRight: '0px' }}><button onClick={this.props.addAppliedFolio} type="button" className="btn btn-secondary btn-sm" ><span className="ss-plus">&nbsp;</span> {I18n.t('add')}</button></div> : null}
            </div>
            <div className={"folios "}>
              {folios && folios.length ? folios : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
            </div>
          </div>
      </div>
    );
  };

  renderCurrencyInput(folio) {
    return(
      <div>
        <label>{I18n.t('amount')} *</label>
        <br />
        <CurrencyInput 
          name="amount" 
          value={folio.amount} 
          className={this.props.hasClassErrors('amount_must_be_greater_than_zero') || this.props.hasClassErrors('amount_cannot_be_zero') ? "form-control has-errors" : "form-control"} 
          onChange={this.props.capture_auth ? this.props.onChangeApplyFoliosAmount : this.props.onChangeFolioField} 
          additionalValue={this.props.capture_auth ? folio.id : folio.folio_id} 
          ignoreComponentWillReceiveProps={this.props.payment_type == 'cash' ? true : false} 
          disabled={this.props.disablAmount} 
        />
        {this.props.renderFieldErrors('amount_must_be_greater_than_zero')}
        {this.props.renderFieldErrors('amount_cannot_be_zero')}
      </div>
    );
  };

  renderFolioDetails(){
    if (this.props.new_record && !this.props.capture_auth && this.props.payment_log_folios){
      var folios = this.props.payment_log_folios.map((plf, idx) => {
        return (
          <div className="folio-amount" key={plf.folio_id} style={{padding:"0rem 1rem"}}>
            <div className="row" >

              <div className="col-md">
                <label>{I18n.t('folio')}</label>
                <br />
                <div>{plf.room ? `${plf.name} - ${plf.room}(${plf.room_type})` : plf.room_type ? `${plf.name} - ${plf.room_type}` : plf.name}</div>
              </div>

              <div className="col-md">
                <label>{I18n.t('balance')}</label>
                <br />
                <div>{this.props.formatCurrency(plf.folio_balance)}</div>
              </div>

              <div className="col-md">
                <div className="amount">
                  {this.renderCurrencyInput(plf)}
                </div>
              </div>

             
            </div>
            <br />
            {this.props.payment_log_folios.length > 1 && (idx != this.props.payment_log_folios.length - 1) ? <hr /> : null}
          </div>
        );
      });
    } else if (this.props.capture_auth){
      var folios = this.props.payment_log_folios.map((plf, idx) => {
        return (
          <div className="folio-amount" key={plf.id} style={{ padding: "0rem 1rem 0rem 0rem" }}>
            <div className="row">

              <div className="col-sm-2">
                <label>{I18n.t('folio')}</label>
                <br />
                {this.renderFolioSelect(plf)}
                {this.props.errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Folio')) && !plf.folio_id ? <div className="help-block"><ul><li key={ this.props.errors.header_errors.find(error => error.includes('Folio')) }><b>&#x2022;</b>{this.props.errors.header_errors.find(error => error.includes('Folio'))}</li></ul></div> : null}
              </div>

              <div className="col-sm-2">
                <label>{I18n.t('balance')}</label>
                <br />
                <div>{plf.folio_balance ? this.props.formatCurrency(plf.folio_balance) : null}</div>
              </div>

              <div className="col-sm-3">
                <div className="amount">
                  {this.renderCurrencyInput(plf)}
                </div>
              </div>

              <div className="col-sm-3">
                <label>{I18n.t('close_folio')} <span className="ss-help help" title={I18n.t('close_folio_helper_text_folio_builder')}></span></label>
                {
                  plf.folio_id
                  ?
                  <Switch
                  onText="yes"
                  offText="no"
                  switchId="payment-settle-folio-switch"
                  value={plf.settled ? plf.settled : false}
                  disabled={plf.folio_balance === plf.amount ? false : true}
                  customChangeHandlerRequired="settlePaymentFolio"
                  onChange={this.props.onChangeFolioField}
                  folioId={plf.folio_id}
                />
                  :
                  null}
              </div>
            <div key="add-buttom" className="col-sm-2 flexed content-right" style={{ marginBottom: '15px', marginTop: '20px', paddingRight: '0px' }}><button onClick={this.props.removeAppliedFolio} name={plf.id} type="button" className="btn btn-secondary btn-sm" ><span className="ss-plus">&nbsp;</span> {I18n.t('remove')}</button></div>
            </div>
            <br />
            {this.props.payment_log_folios.length > 1 && (idx != this.props.payment_log_folios.length - 1) ? <hr /> : null}
          </div>
        );
      });
    };
    return folios
  };

  renderFolioSelect(plf){
    var options = this.props.folios.map((folio, idx) =>{
      return (<option key={idx} value={folio.id}>{folio.room ? `${folio.name} - ${folio.room}(${folio.room_type})` : folio.room_type ? `${folio.name} - ${folio.room_type}` : folio.name}</option>)
    });
    return(
      <select className={this.props.errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Folio')) && !plf.folio_id  ? "form-control has-errors" : "form-control"} value={plf.folio_id ? plf.folio_id : ''} name={plf.id} onChange={this.props.onChangeApplyAuthFolio}>
        <option value="" disabled ></option>
        {options}
      </select>
    );
  };
};

export default FolioWidget
